import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTACTS_CRUD_ACTION_CREATORS } from '../actions/contacts_actions';
import { nullSafeGet, nullSafeGetOrElse } from '../utils/DataAccessUtils';

export const contactsRestCrudThunksForBuyer = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'common_contacts'
);
export const contactsRestCrudThunksForSupplier = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);

export const getContactsRestCrudThunksWithInternalTechs = (userType: string) =>
	new RestCrudThunks(
		'/buyer_internal_team_users_list',
		'contact',
		'contact',
		'contacts',
		CONTACTS_CRUD_ACTION_CREATORS,
		null,
		userType,
		false,
		'common_contacts'
	);

export const contactsRestCrudThunksForSupplierForThirdPartySuppliers = new RestCrudThunks(
	'/supplier_users_list',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);

// Adaptor that maps user.id to the email field to ensure unique keys in the contacts reducer.
// supplier_users_list nests the display fields under `contact`, but the shared all_contacts
// store (and UserName/ContactAvatar, which read nameGiven/nameFamily from the top level)
// expects a flat contact. Lift the name onto the top level so these records render correctly
// wherever they're merged into all_contacts, while keeping the nested `contact` intact for
// callers that read it (e.g. the field tech form).
const contactsEmailAdaptor = (users) =>
	users.map((user) => ({
		...user,
		email: user.id,
		nameGiven: nullSafeGetOrElse('contact.nameGiven', user, ''),
		nameFamily: nullSafeGetOrElse('contact.nameFamily', user, ''),
	}));

// Wrapped read functions that apply the email adaptor
export const getContactsWithInternalTechs = (userType: string) => {
	const thunks = getContactsRestCrudThunksWithInternalTechs(userType);
	return {
		read: (
			params,
			targetCollectionName = null,
			pagination = null,
			sorting = null,
			filters = null,
			addToTargetCollection = false
		) =>
			thunks.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				contactsEmailAdaptor
			),
	};
};

export const getContactsForThirdPartySuppliers = {
	read: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection,
			contactsEmailAdaptor
		),
};

// Supervisor filter uses the same supplier-users API as the field tech form's
// "Supervisors" field, remapping the async-select's `name` param to `search`.
export const getSupervisorsForThirdPartySuppliers = {
	read: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		getContactsForThirdPartySuppliers.read(
			{ search: nullSafeGet('name', params) },
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		),
};
